// snippet: rcep
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './KioskWelcomeScreenLayout.styles';
import {
  KioskWelcomeHeader,
  KioskWelcomeFooter,
  KioskWelcomeScreenMain,
  KioskIdelScreen
} from '..';
import KioskTouchSound from '../Kiosk/TouchSound';
export class KioskWelcomeScreenLayout extends Component {
  static propTypes = {
    test: PropTypes.string
  };

  playTouchSound = () => {
    //e.preventDefault();
    let sound = document.getElementById('touchSound');
    sound.play();
  };

  render() {
    const { classes } = this.props;

    return (
      <div
        onClick={() => {
          this.playTouchSound();
        }}
        className={classNames(classes.container)}
      >
        <KioskWelcomeHeader />
        <KioskWelcomeScreenMain />
        <KioskWelcomeFooter customFooterBottom="0%" />
        <KioskIdelScreen />
        <KioskTouchSound />
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(
  KioskWelcomeScreenLayout
);
